import { Pipe, PipeTransform } from '@angular/core';
import { replaceAll } from 'npx-arc-ui/utils';

@Pipe({
  name: 'formatoRut',
  standalone: true,
})
export class FormatoRutPipe implements PipeTransform {
  transform(params: string | null | undefined) {
    const rut = String(params);
    const _ = replaceAll(rut, '.', '').replace('-', ''),
      rutFormateo = [..._],
      digito = _.slice(_.length - 1);
    rutFormateo.pop();

    return separarPorRango(rutFormateo.reverse(), 3)
      .map((c, index, all) => {
        if (index < all.length - 1) {
          return [...c, '.'].reverse().join('');
        }
        return c.reverse().join('');
      })
      .reverse()
      .concat(['-', ...digito].join(''))
      .join('');
  }
}

function separarPorRango(array: any[], tamaño: number) {
  let resultado = [];
  for (let i = 0; i < array.length; i += tamaño) {
    let subarray = array.slice(i, i + tamaño);
    resultado.push(subarray);
  }
  return resultado;
}
